<template>
  <v-content class="align-center justify-center pt-0 mt-4 mx-4">
    <v-container fluid fill-height class="pl-0 pr-0 pt-0">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg8>
          <v-row>
            <v-col cols="12">
              <v-card class="pa-6" elevation="5" style="border-radius: 6px !important;">
                <v-card-title class="pl-0 pb-8">
                  <span class="headline">Editar meus dados</span>
                </v-card-title>

                <v-row no-gutters>
                  <v-col lg="3" md="12" class="pr-3">
                    <v-text-field
                      label="CPF ou CNPJ"
                      v-model="usuarioLogado.cliente.cliStrDocumento"
                      type="text"
                      :rules="[(v) => !!v || 'CPF ou CNPJ é obrigatório']"
                      required
                      @input="procurarDocumento()"
                      color="var(--vs-azul-secundaria)"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col lg="9" md="12">
                    <v-text-field
                      label="Nome ou Razão Social"
                      :rules="[
                        (v) => !!v || 'Nome ou Razão Social é obrigatório',
                      ]"
                      v-model="usuarioLogado.cliente.cliStrNme"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-text-field
                  label="Telefone"
                  :rules="[(v) => !!v || 'Telefone é obrigatório']"
                  v-model="usuarioLogado.busChaFone1"
                  type="text"
                  v-mask="mask.telefone"
                  required
                  color="var(--vs-azul-secundaria)"
                ></v-text-field>

                <v-row no-gutters>
                  <v-col lg="12" md="12" class="pr-3">
                    <span class="font-weight-bold">Endereço de entrega</span>
                  </v-col>
                  <v-col lg="2" md="12" class="pr-3">
                    <v-text-field
                      label="CEP"
                      :rules="[(v) => !!v || 'CEP é obrigatório']"
                      v-model="usuarioLogado.busChaCep"
                      type="text"
                      v-mask="mask.cep"
                      @input="procurarCEP()"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="10" md="12" class="pr-3">
                    <v-text-field
                      label="Endereço"
                      :rules="[(v) => !!v || 'Endereço é obrigatório']"
                      v-model="usuarioLogado.busStrEndereco"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="Bairro"
                      :rules="[(v) => !!v || 'Bairro é obrigatório']"
                      v-model="usuarioLogado.busStrBairro"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="Cidade"
                      :rules="[(v) => !!v || 'Cidade é obrigatório']"
                      v-model="usuarioLogado.busStrCidade"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="UF"
                      :rules="[(v) => !!v || 'UF é obrigatório']"
                      v-model="usuarioLogado.busChaUf"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- <v-text-field
                  label="Email"
                  v-model="usuarioLogado.busStrLogin"
                  type="text"
                  required
                  color="var(--vs-azul-secundaria)"
                  disabled
                ></v-text-field>-->

                <v-row no-gutters class="pt-7 justify-end">
                  <vs-button
                    color="warning"
                    style="min-width: 140px"
                    animation-type="scale"
                    @click="salvarAlteracoes()"
                  >
                    <template>Salvar alterações</template>
                  </vs-button>

                  <vs-button
                    color="primary"
                    style="min-width: 140px"
                    border
                    @click="$router.push({ name: 'anuncio' })"
                  >
                    <template>Ir para anúncios</template>
                  </vs-button>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  data() {
    return {
      valid: true,
      resultado: "",
      mask: {
        cnpj: "##.###.###/####-##",
        telefone: "(##)#####-####",
        cep: "#####-###"
      },
      step: 1
    };
  },
  computed: {
    ...mapGetters({
      usuarioLogado: "cliente/usuarioLogado",
      config: "cliente/config"
    })
  },
  methods: {
    procurarDocumento() {
      if (this.usuarioLogado.cliente.cliStrDocumento.length >= 11) {
        this.$store.dispatch("cliente/procurarCliente", {
          cliStrDocumento: this.usuarioLogado.cliente.cliStrDocumento,
          empIntCod: this.$route.params.id
        });
      }
    },
    procurarCEP() {
      if (this.usuarioLogado.busChaCep.length === 9) {
        this.$store.dispatch(
          "cliente/procurarCEPUsuarioLogado",
          this.usuarioLogado.busChaCep.replace(".", "").replace("-", "")
        );
      }
    },
    salvarAlteracoes() {
      this.usuarioLogado.busStrLogin = this.usuarioLogado.busStrLogin.toUpperCase();
      this.$store.dispatch("usuario/alterarusuario", this.usuarioLogado);
    }
  }
};
</script>
